// @flow
import * as intercom from './lib'
export default intercom

export const INTERCOM_WIDGET_SIZE = 60
